var path = 'modules/dcb-eaccount.pages.eadashboard/components/lastCinvMini.tpl.html';
var html = "<div ng-controller=\"DashboardGetDasStatisticController as controller\" ng-init=\"controller.ownInit(cadid)\">\n  <div class=\"portlet-body portlet-mini\" ng-class=\"{loading : controller[controller.contractId].loading}\">\n    <dc-spinner></dc-spinner>\n    <h3 class=\"plain-heading\">\n      <small data-i18n=\"modules.dashboard.lastcinv\"></small>\n      <br>\n      {{controller[controller.contractId].lastCinv | money}}\n    </h3>\n  </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./~/ngtemplate-loader?relativeTo=/src/ui/modules/eaDashboard/components&prefix=modules/dcb-eaccount.pages.eadashboard/components!./~/raw-loader!./src/ui/modules/eaDashboard/components/lastCinvMini.tpl.html
// module id = 899
// module chunks = 12